import axios from "axios";
import { toast } from "sonner";

declare module "axios" {
  export interface AxiosInstance {
    request<T = any>(config: AxiosRequestConfig): Promise<T>;

    get<T = any>(url: string, config?: AxiosRequestConfig): Promise<T>;

    delete<T = any>(url: string, config?: AxiosRequestConfig): Promise<T>;

    head<T = any>(url: string, config?: AxiosRequestConfig): Promise<T>;

    post<T = any>(
      url: string,
      data?: any,
      config?: AxiosRequestConfig,
    ): Promise<T>;

    put<T = any>(
      url: string,
      data?: any,
      config?: AxiosRequestConfig,
    ): Promise<T>;

    patch<T = any>(
      url: string,
      data?: any,
      config?: AxiosRequestConfig,
    ): Promise<T>;
  }
}

const axiosInstance = axios.create({
  baseURL: process.env.REACT_APP_BASE_URL,
  headers: {
    "Content-Type": "application/json",
    Accept: "application/json",
  },
  withCredentials: true,
  withXSRFToken: true,
});

axiosInstance.interceptors.response.use(
  (response) => {
    return response.data;
  },
  (error) => {
    if (error?.response?.status === 401) {
      localStorage.clear();
      // eslint-disable-next-line no-restricted-globals
      location.href = "/sign-in";
    } else if (error?.response?.status === 422) {
      const responseData = error?.response?.data as unknown as {
        errors: any;
      };
      const errors: any = {};

      for (const key in responseData?.errors) {
        const error =
          typeof responseData?.errors[key] === "string"
            ? responseData?.errors[key]
            : responseData?.errors[key][0];

        errors[key] = error;
      }

      throw errors;
    } else if (error?.response?.status === 500) {
      console.log(error.response);
      toast.error(null, {
        description: error.response?.data?.message || "خطا در انجام عملیات",
      });
    } else if (error?.response?.status === 404) {
      console.log("404 Not Found", error);
    } else if (error?.response?.status === 504) {
      console.log(error.response);
      toast.error(null, {
        description: error.response?.data?.message || "خطا در انجام عملیات",
      });
    }
    return Promise.reject(error.response);
  },
);

export default axiosInstance;
